import React, { useEffect, createElement } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
export function PrivacyPolicy() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://app.termly.io/embed-policy.min.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <div className="min-h-screen bg-cream" data-id="element-163">
      <div className="max-w-4xl mx-auto px-6 pt-32 pb-20" data-id="element-164">
        <Link to="/" className="inline-flex items-center gap-2 text-warmBrown/60 hover:text-peach transition-colors mb-8 font-medium" data-id="element-165">
          <ArrowLeftIcon size={18} data-id="element-166" />
          Back to Home
        </Link>

        <div name="termly-embed" data-id="633365d3-04be-4eca-9c99-1a882216d05b" data-type="iframe"></div>
      </div>
    </div>;
}